export default __webpack_public_path__ + "static/media/kp.8ed3874a.svg";